import React, { useState } from 'react';
import './style.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, InputText } from 'components';
import { Modal } from 'react-bootstrap';

const regexPhoneNumber = /^\+?(?:[0-9]??).{9,12}[0-9]/;

const AddMemberPopup = ({ isOpenModal, closeModal, confirmAction }) => {
  const [errorMsg, setErrorMsg] = useState('');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  
  const intl = useIntl();

  const handlePhoneNumber = (value) => {
    setPhone(value);
    const test = regexPhoneNumber.test(value);
    if (!test || value.length > 11) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
    } else {
      setErrorMsg('');
    }
  }

  const handleConfirm = () => {
    confirmAction(phone, otp);
  }

  return (
    <Modal show={isOpenModal} onHide={closeModal} className="modal-member">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='IDS_TV_ADD_MORE_MEMBER' /></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mt-4">
          <InputText
            placeholder={intl.formatMessage({ id: 'IDS_SNAPTIENDIENTHOAI' })}
            handleOnChange={handlePhoneNumber}
            errorMsg={errorMsg}
            value={phone}
            onlyNumber
            customClass="modal-member__input"
          />
          <InputText
            placeholder={intl.formatMessage({ id: 'IDS_TV_FORM_OTP' })}
            handleOnChange={(value) => setOtp(value)}
            value={otp}
            onlyNumber
            customClass="modal-member__input"
          />
        </div>
        <div className="modal-member__btn-wrapper display-center">
          <Button onClick={closeModal} buttonClass="mr-3">
            <FormattedMessage id='IDS_SHUYDV' />
          </Button>
          <Button onClick={handleConfirm} disabled={errorMsg || !phone || !otp}>
            <FormattedMessage id='IDS_TV_CONFIRM' />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default React.memo(AddMemberPopup);